module.exports = __webpack_public_path__ + "static/media/intelligentappmobilenew2.dd8a3c03.gif";